export const sortItems = [
	{
		value: 'popular',
		label: `По популярности`
	},
	{
		value: 'price|asc',
		label: `Цена по возрастанию`
	},
	{
		value: 'price|desc',
		label: `Цена по убыванию`
	}
]
